var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-fade-transition',[_c('v-overlay',{attrs:{"absolute":"","color":"#FFFFFF"}},[_c('v-progress-circular',{attrs:{"size":70,"color":"primary","indeterminate":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }